<template>
  <!-- <div class="page-footer pt-4 pb-4 text-center pl-3" style="background-color: #dee5ed; "> -->
  <mdb-footer
   class="text-center pt-4 pb-4 pl-3"
   :style="'background-color: #3a8a65; width: 100%; z-index: 900; bottom: 0 !important; '+position"
  >
    <!-- Footer Links -->

    <div class="container footer-margin" style="font-size: 12px; font-family:Open Sans;">
      <mdb-row style="">
        <mdb-col style="margin-right: 30%;">
           <img src="/img/icons/Lgo.svg" alt="logo tres marias" />
        </mdb-col>
         <mdb-col>
            <span></span>
        </mdb-col>
         <mdb-col>
            <span class="text-style" @click="goToPage">www.clubtresmarias.com</span>
        </mdb-col>
        <mdb-col>
           <div> Desarrollado por <span class="text-style" @click="goToPage2">Kiritek</span></div>
        </mdb-col>
       
      </mdb-row>
    </div>
    <!-- </div> -->
  </mdb-footer>
</template>

<script>
import { mdbFooter, mdbContainer, mdbIcon, mdbRow, mdbCol } from "mdbvue";

export default {
  props: ["absolute"],
  name: "Footer",
  components: {
    mdbContainer,
    mdbIcon,
    mdbRow,
    mdbCol,
    mdbFooter,
  },
  data() {
    return {};
  },
  methods: {
      goToPage(){
          window.location.replace("http://www.clubtresmarias.com/");
      },
      goToPage2(){
          window.location.replace("https://kiritek.com/");
      }
      
  },
  computed:{
      position(){
        if(this.absolute){
          return 'position: absolute;'
        }
        else
          return ''
      }
  }
};
</script>

<style scoped>

.text-style {
    color: #f0f0f0;
    cursor: pointer;
}

.text-style:hover {
    color: #fff;
    text-decoration: underline;
}

footer.page-footer {
    bottom: 0 !important;
    color: #fff;
}

</style>